// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InputParameterType } from './InputParameterEnum';
export class InputParameterBase {
    constructor(variableName = 'Empty', variableType = InputParameterType.STRING, comment = '', inputNumber = 0) {
        this.VariableName = variableName;
        this.VariableType = variableType;
        this.Comment = comment;
        this.InputNumber = inputNumber;
    }
}
